import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
// import { DeleteModalIcon } from '../../media/images/DeleteModalIcon';
import warningLogo from '../../assets/warning.svg';
import styles from './UnitConfirmationModalStyle.module.scss';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 539,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
type TypesConfirmModal = {
  show: boolean;
  setOpenFrom: () => void;
  handleClick: () => void;
};

export default function ComponentConfirmModal({ show, setOpenFrom, handleClick }: TypesConfirmModal): JSX.Element {
  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          {/* <DeleteModalIcon /> */}
          <img src={warningLogo} alt="Warning" height={100} width={100} />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          You have unsaved changes on this Bid. If you proceed to add a unit now, all unsaved changes will be lost. Do you want to continue?
        </div>

        <div className={styles.divButtons}>
          <button
            type="button"
            className={`btn ${styles.deleteBtn}`}
            onClick={() => {
              handleClick();
            }}
          >
            Proceed to Add
          </button>
          <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>Cancel</button>
        </div>
      </Box>
    </Modal>
  );
}
